const ROLE_ADMIN = process.env.VUE_APP_ROLE_ADMIN ? parseInt(process.env.VUE_APP_ROLE_ADMIN) : 1;


export { ROLE_ADMIN };
